'use strict'

export let norwegian_endProject={
  status: {
    green: "Prosjektet er levert innenfor toleransegrensene.",
    yellow: "Prosjektet er hovedsaklig levert innenfor toleransegrensene, men noen få unntaksplaner har vært nødvendig.",
    red: "Prosjektet har brutt toleransegrensene flere ganger og mange unntaksplaner har vært nødvendig."
  }
}



// WEBPACK FOOTER //
// ./views/components/labels/norwegian_endProject.js